// eslint-disable-next-line import/no-unresolved
import './styles/main.css';
import './index.css';
import './sentry';

import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';

import { getBackendApolloLinks } from './apolloLinks';
import App from './App';
import * as serviceWorker from './serviceWorker';

// To use payment cilent:
// useQuery(QUERY, { variables, context: { clientName: PAYMENT_CLIENT } })
const apolloClient = new ApolloClient({
  link: getBackendApolloLinks(),
  cache: new InMemoryCache()
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
